import * as React from 'react';

const LeftArrow = (props) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M21.1658 12.366L15.9319 17.6L21.1658 22.834C21.2049 22.873 21.2391 22.9151 21.2684 22.9595C21.4735 23.2701 21.4392 23.6922 21.1658 23.9656C20.8533 24.2781 20.3467 24.2781 20.0342 23.9656L14.2344 18.1658C14.0843 18.0158 14 17.8123 14 17.6C14 17.3878 14.0843 17.1843 14.2344 17.0341L20.0342 11.2344C20.3467 10.9219 20.8533 10.9219 21.1658 11.2344C21.4784 11.5469 21.4784 12.0535 21.1658 12.366Z"
      fill="#5C5C5C"
    />
  </svg>
);
export default LeftArrow;
